import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import GochiTableHead from '../../components/molecules/GochiHistoryTableHead';
import GochiTableBody from '../../components/molecules/GochiHistoryTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import ContentDialog from '../../components/molecules/ContentDialog';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import { sendLogin } from '../../auth/Auth';
import {
  deleteGochi,
  deleteCommentShashoku,
  updateGochiKidReceiptFlag,
  DELETE_COMMENT_SHASHOKU_SUCCESS,
  UPDATE_GOCHI_KID_RECEIPT_FLAG_SUCCESS
} from '../../actions/Gochis';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmChangeGochiKidReceiptDialog from '../../components/molecules/ConfirmChangeGochiKidReceiptDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      gochis: state.gochis,
      totalCount: state.gochis.totalCount,
      count: state.gochis.count,
      offset: state.gochis.offset,
      couponCountTotal: state.gochis.couponCountTotal,
      externalAmountTotal: state.gochis.externalAmountTotal,
      internalAmountTotal: state.gochis.internalAmountTotal,
      couponUsedCountTotal: state.gochis.couponUsedCountTotal,
      usedExternalAmountTotal: state.gochis.usedExternalAmountTotal,
      usedInternalAmountTotal: state.gochis.usedInternalAmountTotal,
      discountAmountTotal: state.gochis.discountAmountTotal,
      transferAmountTotal: state.gochis.transferAmountTotal,
      amountTransferToShopWhenUseTotal:
        state.gochis.amountTransferToShopWhenUseTotal,
      amountTransferToShopWhenBuyTotal:
        state.gochis.amountTransferToShopWhenBuyTotal
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          deleteGochi,
          deleteCommentShashoku,
          updateGochiKidReceiptFlag
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('deleteMessage', 'setDeleteMessage', ''),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('openDeleteComment', 'updateOpenDeleteComment', false),
  withState(
    'openChangeGochiKidReceiptDialog',
    'updateOpenChangeGochiKidReceiptDialog',
    false
  ),
  // withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => event => {
      // props.setRowsPerPage(rowsPerPage);
      // props.handleChangePage(event, 0);
      props.setRowsPerPage(event.target.value);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    actions,
    selectedPage,
    handleChangePage,
    handleDeleteGochi,
    checkSession,
    gochis,
    count,
    offset,
    couponCountTotal,
    externalAmountTotal,
    internalAmountTotal,
    couponUsedCountTotal,
    usedExternalAmountTotal,
    usedInternalAmountTotal,
    discountAmountTotal,
    transferAmountTotal,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    updateOpenDelete,
    openDelete,
    loading,
    updateLoading,
    updateOpenDeleteProgress,
    openDeleteProgress,
    roles,
    setResultMessage,
    updateIsDeleteSuccess,
    isDeleteSuccess,
    resultMessage,
    deleteMessage,
    setDeleteMessage,
    searchEs,
    isShop,
    amountTransferToShopWhenUseTotal,
    amountTransferToShopWhenBuyTotal,
    isFukuoka,
    isNaha,
    openDeleteComment,
    updateOpenDeleteComment,
    educateSystem,
    openUpdateAmountModal,
    openUpdateAmountHistory,
    openChangeGochiKidReceiptDialog,
    updateOpenChangeGochiKidReceiptDialog
  }) => {
    const totals = {
      couponCountTotal,
      externalAmountTotal,
      internalAmountTotal,
      couponUsedCountTotal,
      usedExternalAmountTotal,
      usedInternalAmountTotal,
      discountAmountTotal,
      transferAmountTotal,
      amountTransferToShopWhenUseTotal,
      amountTransferToShopWhenBuyTotal
    };

    const moreMessageAction = msg => {
      setFullMessage(msg);
      updateOpenFullMessage(true);
    };

    const deleteOpenAction = id => {
      let readyUse = false;
      if (searchEs) {
        gochis.gochisAll
          .filter(item => item.gochiBillId === id)
          .forEach(gochi => {
            if (gochi.coupons) {
              gochi.coupons.forEach(coupon => {
                if (coupon.useDate != null) {
                  readyUse = true;
                }
              });
            }
          });
      } else {
        gochis.gochis
          .filter(item => item.gochiBillId === id)
          .forEach(gochi => {
            if (gochi.coupons) {
              gochi.coupons.forEach(coupon => {
                if (coupon.useDate != null) {
                  readyUse = true;
                }
              });
            }
          });
      }
      if (readyUse) {
        setDeleteMessage(
          '利用されたクーポンが含まれます。ごちを削除してもよろしいですか？'
        );
      }

      updateOpenDelete(true);
      setTargetRowId(id);
    };

    const cancelAction = () => updateOpenDelete(false);

    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedGochi = await actions
        .deleteGochi(targetRowId)
        .then(data => checkSession(data));
      if (deletedGochi.type === 'DELETE_GOCHI_SUCCESS') {
        updateIsDeleteSuccess(true);
        updateOpenDelete(false);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        updateOpenDelete(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const deleteCommentOpenAction = id => {
      setDeleteMessage('コメントを削除してもよろしいですか？');
      updateOpenDeleteComment(true);
      setTargetRowId(id);
    };

    const cancelDeleteCommentAction = () => updateOpenDeleteComment(false);

    const deleteCommentAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      updateOpenDeleteComment(false);
      const deleteComment = await actions
        .deleteCommentShashoku({ shashokuTicketId: targetRowId })
        .then(data => checkSession(data));
      if (deleteComment.type === DELETE_COMMENT_SHASHOKU_SUCCESS) {
        updateIsDeleteSuccess(true);
        setResultMessage('削除が完了しました。');
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('エラーが発生しました！');
      }
      updateLoading(false);
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDeleteProgress(false);
        handleDeleteGochi(null, selectedPage, rowsPerPage);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    const openConfirmChangeGochiKidReceipt = esGochiId => {
      setTargetRowId(esGochiId);
      updateOpenChangeGochiKidReceiptDialog(true);
    };

    const cancelChangeGochiKidReceiptAction = () => {
      updateOpenChangeGochiKidReceiptDialog(false);
    };

    const changeGochiKidReceiptAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      updateOpenChangeGochiKidReceiptDialog(false);
      const response = await actions
        .updateGochiKidReceiptFlag({ esGochiId: targetRowId })
        .then(data => checkSession(data));
      if (response.type === UPDATE_GOCHI_KID_RECEIPT_FLAG_SUCCESS) {
        updateIsDeleteSuccess(true);
        setResultMessage('データ更新に成功しました。');
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('データ更新に失敗しました。');
      }
      updateLoading(false);
    };

    let totalGochi = 0;
    if (gochis.gochis && gochis.gochis.length) {
      totalGochi = gochis.gochis.length;
    } else if (gochis.gochisAll && gochis.gochisAll.length) {
      totalGochi = gochis.gochisAll.length;
    }

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalGochi - page * rowsPerPage);

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              totals={totals}
              roles={roles}
              isShop={isShop}
              isFukuoka={isFukuoka}
              educateSystem={educateSystem}
            />
            <GochiTableBody
              gochis={gochis.list}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              messageViewAction={moreMessageAction}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
              deleteOpenAction={deleteOpenAction}
              roles={roles}
              searchEs={searchEs}
              isShop={isShop}
              isFukuoka={isFukuoka}
              isNaha={isNaha}
              deleteCommentOpenAction={deleteCommentOpenAction}
              openUpdateAmountModal={openUpdateAmountModal}
              openUpdateAmountHistory={openUpdateAmountHistory}
              openConfirmChangeGochiKidReceipt={
                openConfirmChangeGochiKidReceipt
              }
            />
          </Table>
        </div>
        {/* {!searchEs && !isShop ? (
          <div>
            <TablePagination
              searchResults={gochis.list}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={count}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        ) : ( */}
        <div>
          <ExPagination
            searchResults={gochis.list}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={count}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        {/* )} */}
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="ごち"
          deleteMessage={deleteMessage}
        />
        <DeleteDialog
          openDelete={openDeleteComment}
          updateOpenDelete={updateOpenDeleteComment}
          cancelAction={cancelDeleteCommentAction}
          deleteAction={deleteCommentAction}
          target="ごち"
          deleteMessage={deleteMessage}
        />
        <ConfirmChangeGochiKidReceiptDialog
          openDelete={openChangeGochiKidReceiptDialog}
          updateOpenDelete={updateOpenChangeGochiKidReceiptDialog}
          cancelAction={cancelChangeGochiKidReceiptAction}
          deleteAction={changeGochiKidReceiptAction}
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
